module.exports = __webpack_public_path__ + "static/img/game-icon1.a7e22fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/game-icon1.png
// module id = Ucc6
// module chunks = 0